import { account } from './account';
import { apps } from './apps';
import { chat } from './chat';
import { common } from './common';
import { help } from './help';
import { site } from './site';

// Every English catalog, merged. Each area lives in its own file so screens
// can be translated independently.
export const en = {
  ...common,
  ...chat,
  ...account,
  ...apps,
  ...site,
  ...help,
} as const;

export type MessageKey = keyof typeof en;
